__webpack_require__.p = "/PokeAPI-front/";